<template>
  <div
    class="app-content content"
    :style="$route.name == 'v1_experiment_details_1' || $route.name == 'v1_experiment_details_2' || $route.name == 'v1_experiment_details_3' || $route.name == 'v2_experiment_details_1' || $route.name == 'v2_experiment_details_2' || $route.name == 'v2_experiment_details_3'? 'margin-left: 6%' : '' "
    :class="[{'show-overlay': $store.state.app.shallShowOverlay}, $route.meta.contentClass]"
  >
    <div class="content-overlay" />
    <!-- <div class="header-navbar-shadow" /> -->
    <div
      class="content-wrapper"
      :class="contentWidth === 'boxed' ? 'container p-0' : null"
    >
      <slot name="breadcrumb">
        <app-breadcrumb />
      </slot>
      <div class="content-body">
        <transition
          :name="routerTransition"
          mode="out-in"
        >
          <slot />
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import AppBreadcrumb from '@core/layouts/components/AppBreadcrumb.vue'
import useAppConfig from '@core/app-config/useAppConfig'

export default {
  components: {
    AppBreadcrumb,
  },
  setup() {
    const { routerTransition, contentWidth } = useAppConfig()

    return {
      routerTransition, contentWidth,
    }
  },
}
</script>

<style>

</style>
